"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.House = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var House = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M1 12L12 2l11 10h-3v10h-6v-7h-4v7H4V12H1z" })); };
exports.House = House;
//# sourceMappingURL=house.js.map